import React from "react"
import lodash from "lodash"
import axios from "axios"
import { Spin } from "antd"

import { LoadingOutlined } from "@ant-design/icons"

import { AdminService } from "@/services"

import FileUploader from "./fileUploader"

export {
    FileUploader
}

const TokenName = "jowo-studio-admin-token"

export const getToken = () => localStorage.getItem(TokenName)

export const setToken = (value) => localStorage.setItem(TokenName, value)

export const deleteToken = () => localStorage.removeItem(TokenName)

let memoCurrentUser = null // 本地缓存当前用户信息,避免反复请求

export const getCurrentUser = () => lodash.cloneDeep(memoCurrentUser)

export const setCurrentUser = (user) => memoCurrentUser = user

export const checkLogin = () => {
    const token = getToken()
    return !!(token && memoCurrentUser)
}

export const checkCurrentUser = async () => {

    const token = getToken()
    if (!token) return null

    if (memoCurrentUser) return memoCurrentUser

    const response = await AdminService.check_token({ token: token })

    const { status, body } = response.data

    // token校验不通过时，退出登录状态
    if (status <= 0) {
        logout()
        return null
    }

    const { uid, nickname, head_pic } = body

    setCurrentUser({
        token,
        uid,
        nickname,
        head_pic
    })

    return true
}

export const logout = () => {
    deleteToken()
    memoCurrentUser = null
}

export const createFormData = (params) => {
    const formData = new FormData()
    Object.entries(params).forEach(([key, value]) => {
        formData.set(key.toString(), value)
    })
    return formData
}

export const createAxiosWithToken = () => {
    return axios.create({
        headers: {
            'HTTP-JOWO-STUDIO-TOKEN': getToken()
        }
    })
}


const PlatformDict = {
    common: "通用",
    jowoiot: "九物云"
}

export const formatPlatform = (platform) => {
    return PlatformDict[platform] || ""
}

export const sayHi = () => console.log("hi!")

export const renderLoading = () => {
    const loadingIcon = <LoadingOutlined type="loading" style={{ fontSize: 30, marginBottom: 10 }} spin />
    const style = {
        display: "flex",
        width: "100%",
        height: "100%",
        alignItems: "center",
        justifyContent: "center"
    }
    return (
        <div style={style}>
            <Spin tip="正在加载中..." indicator={loadingIcon}></Spin>
        </div>
    )
}

